import { Boxes } from 'lucide-react'
import { useState } from 'react'

import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'
import FilterManagementDropdown from '../needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from '../needs_attention/utils'
import { type MultipleSelectedValuesFilter } from '../types'

// Coverage type options based on the main categories
const coverageTypeOptions: ComboboxFilterOption<string>[] = [
  { label: 'Medical', value: 'medical' },
  { label: 'Dental', value: 'dental' },
  { label: 'Vision', value: 'vision' },
]

const CoverageTypeFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const filteredOptions = coverageTypeOptions.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[
          {
            groupLabel: 'Coverage Types',
            options: filteredOptions,
          },
        ]}
        placeholder='Search coverage types to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={coverageTypeOptions}
          noSelectionText='Coverage Type'
          pluralIdentifier='coverage types'
        >
          <Boxes size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default CoverageTypeFilter
